import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getBlogApiCall = createAsyncThunk("blogList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: blogList } = await API.getBlogApi(submitData);
        //  console.log("*********************************************",letterList);
        dispatch(setLoader(false))
        return blogList;
    } catch (error) {
        throw error;
    }
});

export const editBlogApiCall = createAsyncThunk("editBlogListData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        // console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editBlogData, code, message } = await API.updateBlogApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editBlogData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    blogList: {
        data: [],
        error: null,
    },
    editBlogData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const BlogSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBlogApiCall.fulfilled, (state, action) => {
                state.blogList.data = action.payload;
            })
            .addCase(getBlogApiCall.rejected, (state, action) => {
                state.blogList.error = action.error.message;
            })
            .addCase(editBlogApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editBlogData.data = data;
                state.editBlogData.message = message;
                state.editBlogData.code = code;
            })
            .addCase(editBlogApiCall.rejected, (state, action) => {
                state.editBlogData.error = action.error.message;
            });
    },
});

export default BlogSlice.reducer;